<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7.25 1.54A6.5 6.5 0 1 0 14.46 8.75H7.25V1.54Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M9.75 1.2V6.25h5.05A5.3 5.3 0 0 0 9.75 1.2Z" fill="currentColor"/>
  </svg>
</template>
